/**
 * @file components/home/FieldGalleryItem.tsx
 * @description 公開首頁「現場稽核軌跡」畫廊的單格元件。
 *
 * 結構：21:10 容器 + 真實照片。
 * 場景圖示、場景名（左下）與地點（右下）已烘焙在圖內，因此元件層不再額外疊加 caption。
 * Hover 行為：微浮起 + 細微陰影。
 */

import type { FieldGalleryEntry } from '@/components/home/home-data';

interface FieldGalleryItemProps {
  item: FieldGalleryEntry;
}

export function FieldGalleryItem({ item }: FieldGalleryItemProps) {
  return (
    <figure
      style={{
        position: 'relative',
        margin: 0,
        aspectRatio: '21 / 10',
        borderRadius: 10,
        overflow: 'hidden',
        border: '1px solid var(--stone-200)',
        background: 'var(--stone-100)',
        transition: 'all 200ms ease-out',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 10px 24px -14px rgba(0,0,0,0.18)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      <img
        src={item.imageSrc}
        alt={item.imageAlt}
        loading="lazy"
        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
      />
      {/* 視覺標籤已烘焙在圖內；保留 figcaption 僅供無障礙讀取，不渲染於版面 */}
      <figcaption className="sr-only" style={visuallyHidden}>
        {item.label}（{item.sub}）
      </figcaption>
    </figure>
  );
}

const visuallyHidden: React.CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
};
